<script setup lang="ts">
  import { useAppStore } from '@/stores/app-store';

  useHead({
    title: ''
  });

  const localePath = useLocalePath();

  const { endFadeNavigation } = useAppStore();

  onMounted(() => {
    endFadeNavigation();
  });
</script>

<template>
  <main>
    <UseCaseCustomPackageSection :locale-path="localePath" />
  </main>
</template>
